(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cpp-eu-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cpp-eu-order')) {
    class CppEuOrder extends HTMLElement {
      static values = null;
      static queue = Promise.resolve();
      static resumedForms = new WeakSet();

      connectedCallback() {
        this.controller = new AbortController();
        this.fields = Array.from(this.querySelectorAll('[data-eu-field]'));
        this.error = this.querySelector('[role="alert"]');
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form) return;
        if (CppEuOrder.values) this.restore(CppEuOrder.values);
        else CppEuOrder.values = this.read();
        const options = { signal: this.controller.signal };
        this.addEventListener('input', () => this.synchronize(), options);
        this.addEventListener('change', () => {
          this.normalize();
          this.synchronize();
          this.persist().catch(() => this.showError());
        }, options);
        document.addEventListener('submit', (event) => this.onSubmit(event), {
          capture: true,
          signal: this.controller.signal
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      read() {
        return Object.fromEntries(this.fields.map((field) => [
          field.name.slice(11, -1),
          field.type === 'checkbox' ? (field.checked ? field.value : '') : field.value
        ]));
      }

      restore(values) {
        this.fields.forEach((field) => {
          const value = values[field.name.slice(11, -1)] || '';
          if (field.type === 'checkbox') field.checked = value === field.value;
          else field.value = value;
        });
      }

      normalize() {
        const company = this.querySelector('[data-eu-field="company"]');
        const email = this.querySelector('[data-eu-field="email"]');
        company.value = company.value.trim();
        email.value = '';
      }

      synchronize() {
        CppEuOrder.values = this.read();
        document.querySelectorAll('cpp-eu-order').forEach((component) => {
          if (component !== this && component.fields) component.restore(CppEuOrder.values);
        });
      }

      persist() {
        const attributes = this.read();
        this.error.hidden = true;
        CppEuOrder.queue = CppEuOrder.queue.catch(() => {}).then(async () => {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes })
          });
          if (!response.ok) throw new Error('Cart update failed');
          const result = await response.json();
          if (result.status || !result.attributes) throw new Error('Cart update failed');
        });
        return CppEuOrder.queue;
      }

      showError() {
        this.error.textContent = this.dataset.saveError;
        this.error.hidden = false;
      }

      async onSubmit(event) {
        const form = event.target;
        const ownForm = form === this.form;
        const spareSeal = form.matches('.cpp-spare-seal__form') &&
          document.querySelector('cpp-eu-order') === this;
        if (!ownForm && !spareSeal) return;
        if (CppEuOrder.resumedForms.has(form)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy) return;
        this.normalize();
        this.synchronize();
        const submitter = event.submitter;
        if (ownForm && submitter?.name === 'checkout') {
          for (const field of this.fields) {
            if (!field.reportValidity()) return;
          }
        }
        this.busy = true;
        try {
          await this.persist();
          CppEuOrder.resumedForms.add(form);
          form.requestSubmit(submitter || undefined);
          CppEuOrder.resumedForms.delete(form);
        } catch {
          this.showError();
        } finally {
          this.busy = false;
        }
      }
    }
    customElements.define('cpp-eu-order', CppEuOrder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cpp-policy-page"] && !Shopify.designMode) return;
  try {
    function initializeCppPolicyPages() {
    document.querySelectorAll('[data-cpp-policy-page]').forEach((page) => {
      if (page.dataset.cppPolicyReady) return;
      page.dataset.cppPolicyReady = 'true';
      const contact = page.querySelector('#cpp-contact-information');
      if (contact) {
        contact.querySelectorAll('a').forEach((link) => {
          const href = link.getAttribute('href') || '';
          if (href && !href.startsWith('file:')) return;
          const text = link.textContent.trim().toLowerCase();
          if (text === 'send an enquiry') link.setAttribute('href', page.dataset.contactUrl);
          if (text === 'refund policy' && page.dataset.refundUrl) link.setAttribute('href', page.dataset.refundUrl);
        });
      }
      page.querySelectorAll('.shopify-policy__body p').forEach((source) => {
        if (!source.querySelector('br') || (source.textContent.match(/SECTION \d+ - /g) || []).length < 4) return;
        const lines = [[]];
        source.childNodes.forEach((node) => {
          if (node.nodeName === 'BR') lines.push([]);
          else lines[lines.length - 1].push(node.cloneNode(true));
        });
        const output = document.createDocumentFragment();
        let paragraph = null;
        const flush = () => {
          if (paragraph && paragraph.textContent.trim()) output.appendChild(paragraph);
          paragraph = null;
        };
        lines.forEach((nodes) => {
          const text = nodes.map((node) => node.textContent).join('').trim();
          if (!text) { flush(); return; }
          if (text === '----') {
            flush();
            const divider = document.createElement('hr');
            divider.className = 'cpp-policy-divider';
            output.appendChild(divider);
            return;
          }
          if (text === 'OVERVIEW' || /^SECTION \d+ - /.test(text)) {
            flush();
            const heading = document.createElement('h2');
            nodes.forEach((node) => heading.appendChild(node));
            output.appendChild(heading);
            return;
          }
          if (text === 'TERMS OF SERVICE') {
            flush();
            const title = document.createElement('p');
            title.className = 'cpp-policy-document-title';
            nodes.forEach((node) => title.appendChild(node));
            output.appendChild(title);
            return;
          }
          if (!paragraph) paragraph = document.createElement('p');
          if (paragraph.childNodes.length) paragraph.appendChild(document.createTextNode(' '));
          nodes.forEach((node) => paragraph.appendChild(node));
          if (/[.!?]$/.test(text)) flush();
        });
        flush();
        source.replaceWith(output);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCppPolicyPages);
  else initializeCppPolicyPages();
  document.addEventListener('shopify:section:load', initializeCppPolicyPages);
  } catch(e) { console.error(e); }
})();

})();
